export const calculateDownByPercent = (downPercentage: number, pfr: number) => { // enter .02 for 2%, .2 for 20%, etc. Don't enter '20%'
  return roundToTwoDecPlaces(pfr * downPercentage);
};

export const calculateTermPmt = (pfr: number, downPayment: number, term: number) => {
  return roundToTwoDecPlaces((pfr - downPayment) / term);
};

export const calculateDownPmt = (pfr: number, termPayment: number, term: number) => {
  return roundToTwoDecPlaces(pfr - (termPayment * term));
}

export const calculateTerm = (pfr: number, downPayment: number, termPayment: number) => {
  return roundToTwoDecPlaces((pfr - downPayment) / termPayment);
}

export const calculatePFR = (downPayment: number, termPayment: number, term: number) => {
  return roundToTwoDecPlaces(downPayment + (termPayment * term));
}

export const roundToTwoDecPlaces = (num: number) => {
  return (Math.round(num * 100) / 100);
}

export const formatNumberToUSD = (num?: number) => {
  if (typeof num === 'number' && !isNaN(num)) {
    let formattedNum = (Math.abs(num)).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    if (num < 0) {
      formattedNum = "(" + formattedNum + ")";
    }
    return formattedNum;
  } else { // input was not a number. invalid input. return formatted $0.00.
    return (0).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
};

// ---------------------------------------------------------------------------
// Currency input helpers (for amount fields: parse, format display, strip)
// ---------------------------------------------------------------------------

/** Parse amount string (e.g. "1,234.56") to number. Returns 0 if invalid. */
export const parseAmount = (amountStr: string): number => {
  return Number(String(amountStr).replace(/,/g, '')) || 0;
};

/** Format number as currency input string (e.g. 1234.56 -> "1,234.56"). */
export const formatCurrencyInput = (n: number): string => {
  return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/** Strip input to valid currency digits (one dot, max 2 decimal places). */
export const stripCurrencyInput = (value: string): string => {
  const rawValue = value.replace(/[^0-9.]/g, '');
  const parts = rawValue.split('.');
  let cleanValue = parts[0] ?? '';
  if (parts.length > 1) {
    cleanValue += '.' + (parts[1] ?? '').substring(0, 2);
  }
  return cleanValue;
};

export const formatNumberToUSDWithNegativeValues = (num?: number) => {
  if (typeof num === 'number' && !isNaN(num)) {
    let formattedNum = num.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return formattedNum;
  } else { // input was not a number. invalid input. return 0.
    return 0;
  }
}

export const calculateDiscount = (pfrAmt: number, discountAmt: number) => {
  return roundToTwoDecPlaces(pfrAmt * (1 - (discountAmt / 100)))
}

export const eighteenYearsAgo = (): Date => {
  const today = new Date();
  return new Date(today.setMonth(today.getMonth() - 12 * 18));
}

export const getOrdinalSuffix = (number: number) => {

  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th';
  if (lastDigit === 1) return 'st';
  if (lastDigit === 2) return 'nd';
  if (lastDigit === 3) return 'rd';
  return 'th';
}

